import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NxiCommonModule } from '@pershing/nxi-common';
import { ModPreloginModule } from '@pershing/nxi-ng-mod';
import { NavigationComponent } from './components/navigation.component';
import { NavigationBaseComponent } from './components/navigation-base.component';
import { MobileNavComponent } from './components/mobile-nav.component';
import { ADANavComponent } from './components/ada-nav.component';
import { BreadcrumbComponent } from './components/breadcrumb.component';
import { SecondLevelNavigationComponent } from './components/secondlevel-navigation.component';
import { ThirdLevelComponent } from './components/thirdlevel-navigation.component';
import { FourthLevelComponent } from './components/fourthlevel-navigation.component';
import { ScreenerNavComponent } from './components/screener-navigation.component';
import { IconsComponent } from './components/icons.component';
import { ThirdLevelAdaComponent } from './components/thirdlevel-navigation-ada.component';
import { MobileDropDownComponent } from './components/mobile-dropdown-nav.component';
import { MobileFourthLevelNavComponent } from './components/mobile-fourthlevel-nav.component';
import { ThirdLevelMobileComponent } from './components/thirdlevel-navigation-mobile.component';
import { NxiMobileComponent } from './components/nxi-mobile.component';
import { TradingMobileNavComponent } from './components/trading-mobile-nav.component';
import { ScreenerNavCustomComponent } from './components/screener-navigation-custom.component';
import { GoPaperlessComponent } from './components/go-paperless.component';
import { NxiIconService } from './services/icon.service';
import { NxiMobileService } from './services/nxi-mobile.service';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';

const NXI_NAVIGATION_COMPONENTS = [ NavigationBaseComponent, NavigationComponent,
  MobileNavComponent, ADANavComponent, BreadcrumbComponent, SecondLevelNavigationComponent,
  ThirdLevelComponent, FourthLevelComponent, ScreenerNavComponent, IconsComponent,
  ThirdLevelAdaComponent, ThirdLevelMobileComponent, MobileDropDownComponent,
  MobileFourthLevelNavComponent, NxiMobileComponent, TradingMobileNavComponent,
  ScreenerNavCustomComponent, GoPaperlessComponent
];

const NXI_NAVIGATION_SERVICES = [
    NxiMobileService,
    NxiIconService
];

@NgModule({
    imports: [NxiCommonModule, RouterModule, ModPreloginModule,
      MatOptionModule, MatSelectModule, MatTooltipModule],
    declarations: [...NXI_NAVIGATION_COMPONENTS],
    exports: [...NXI_NAVIGATION_COMPONENTS],
    providers: [...NXI_NAVIGATION_SERVICES]
})
export class NxiNavigationModule { }
